import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ConfigOpenStackRegionItem from './ConfigOpenStackRegionItem'

const ConfigOpenStackItem = (props) => {
  const {
    title,
    service,
    expandedPanel,
    handleChangeExpandedPanel,
    backendUserData,
    setBackendUserData,
    getRegionConfig,
    backendIsIdentityProviderSelected,
    errors,
    setErrors,
    submitted,
    validateFormFields,
    appCredentialSecret,
    setAppCredentialSecret,
  } = props
  const theme = useTheme()

  const [expandedSubPanel, setExpandedSubPanel] = useState(0)
  const [regionConfigs, setRegionConfigs] = useState([])
  const [isIdentityProvider, setIsIdentityProvider] = useState(false)

  const accordionStyle = {
    background: 'none',
    boxShadow: 'none'
  }

  const summaryStyle = {
    background: theme.palette.violetsAreBlue,
    color: 'white',
    fontSize: '18px',
  }

  const detailsStyle = {
    border: `${theme.palette.violetsAreBlue} 1px solid`,
    background: 'white',
    boxShadow: 'none',
    padding: '0px',
  }

  const regionSummaryStyle = {
    borderBottom: `${theme.palette.oxfordBlue} 1px solid`,
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
  }

  const handleClickAddRegion = (event) => {    
    if (expandedPanel === service) {
      event.stopPropagation()
    }

    setBackendUserData(prev => [
      ...prev,
      {
        service,
        ...getRegionConfig(service, title.value, regionConfigs.length + 1)
      }      
    ])
  }

  const handleClickRemoveRegion = (event, region_name) => {
    event.stopPropagation()
    setBackendUserData(prev => prev.filter(item => (item.service !== service || item.region_name !== region_name)))
  }

  const handleChangeExpandedSubPanel = (panel) => (event, newExpanded) => {
    setExpandedSubPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    const identity_service = backendUserData.find(item => item.service === service && item.is_identity_provider)
    setIsIdentityProvider(identity_service ? true : false)
    setRegionConfigs(backendUserData.filter(item => item.service === service))
  }, [backendUserData, service])
  
  return (
    <Accordion
      expanded={expandedPanel === service}
      onChange={handleChangeExpandedPanel(service)}
      sx={accordionStyle}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon sx={{ color: 'white' }} />}
        sx={{
          ...summaryStyle,
          borderRadius: expandedPanel === service ? '10px 10px 0px 0px' : '0px',
        }}
      >
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-start'
          spacing={1}
        >
          <Box>{title.value}</Box>
          {
            !isIdentityProvider &&
            <IconButton sx={{ color: 'white' }} onClick={handleClickAddRegion}>
              <AddCircleOutlineIcon />
            </IconButton>
          }          
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={detailsStyle}>
        {
          regionConfigs.length === 1 && regionConfigs.map((item, index) => (
            <ConfigOpenStackRegionItem
              key={index}
              {...item}
              service={service}
              setBackendUserData={setBackendUserData}
              backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
              errors={errors}
              setErrors={setErrors}
              submitted={submitted}
              validateFormFields={validateFormFields}
              appCredentialSecret={appCredentialSecret}
              setAppCredentialSecret={setAppCredentialSecret}
            />
          ))
        }

        {
          regionConfigs.length > 1 && regionConfigs.map((item, index) => (
            <Accordion
              key={index}
              expanded={expandedSubPanel === index}
              onChange={handleChangeExpandedSubPanel(index)}
              sx={accordionStyle}
            >
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                sx={regionSummaryStyle}
              >
                <Stack
                  direction='row'
                  alignItems='center'
                  justifyContent='flex-start'
                  spacing={1}
                >
                  <Box>{item.region_name}</Box>
                  {
                    index > 0 &&
                    <IconButton onClick={(event) => handleClickRemoveRegion(event, item.region_name)}>
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  }          
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <ConfigOpenStackRegionItem
                  key={index}
                  {...item}
                  service={service}
                  setBackendUserData={setBackendUserData}
                  backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
                  errors={errors}
                  setErrors={setErrors}
                  submitted={submitted}
                  validateFormFields={validateFormFields}
                  appCredentialSecret={appCredentialSecret}
                  setAppCredentialSecret={setAppCredentialSecret}
                />
              </AccordionDetails>              
            </Accordion>            
          ))
        }
      </AccordionDetails>
    </Accordion>
  )
}

export default ConfigOpenStackItem